{
  "maxCompare": 5,
  "assetsFolder": "https://s1.quebecormedia.com/infojdem/2023/palmares-des-ecoles-assets/",
  "iconTrendEqual": "<span class='material-symbols-rounded make-smaller'>equal</span>",
  "iconTrendUp": "<span class='material-symbols-rounded'>arrow_outward</span>",
  "iconTrendDown": "<span class='material-symbols-rounded rotate-ninety'>arrow_outward</span>",
  "mobileQuery": "(max-width:449px)"
}
